import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import Lock from 'components/Icons/Lock'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import ContactSupportLink from '../ContactSupportLink'

const t = buildTranslate('live_updates.push_disabled')

const PushDisabledNotice = () => {
  const [css] = useStyletron()

  return (
    <div
      data-testid="lu-preview-push-disabled-notice"
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        padding: '16px',
        borderRadius: '12px',
        backgroundColor: palette.grey10,
        textAlign: 'center',
      })}
    >
      <span aria-hidden="true" className={css({ display: 'flex' })}>
        <Lock fillColor={palette.grey90} />
      </span>
      <Text.BodyText5 bold color="grey90">
        {t('notice_title')}
      </Text.BodyText5>
      <Text.BodyText5 color="grey70">{t('body')}</Text.BodyText5>
      <ContactSupportLink small />
    </div>
  )
}

export default PushDisabledNotice
